import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { decodeHTML } from '../helpers';
import '../find-polyfill';

import TagList from './TagList';

class Post extends Component {
  render() {
    const post = this.props.post;

    let postType = function() { // Return the post type as text, potentially with the resource type if it's a resource.
      if (post.type === 'topic') {
        return 'Topic';
      } 
      else if (post.type === 'news-events') {
        // Grab categories from wpData
        function isCategories(obj) { return obj.name === 'categories'; }
        let wpCategories = this.props.wpData.taxonomies.find(isCategories);
        
        // Grab the category name from the list of categories
        if (post.categories.length > 0) {
          let categoryID = post.categories[0];
          function isCategory(obj) { return obj.id === categoryID; }
          let category = wpCategories.terms.find(isCategory);
          return category.name;
        } 
        else { // No categories on the post, just return the post type
          return 'News & Events';
        }
      } 
      else if (post.type === 'page') {
        return 'Page';
      }
      else if (post.type === 'resource') {
        // Grab resource types from wpData
        function isResourceTypes(obj) { return obj.name === 'resourceType'; }
        let wpResourceTypes = this.props.wpData.taxonomies.find(isResourceTypes);
        // Grab the resource type name from the list of resource types
        if (post.resourceType.length > 0) {
          let resourceTypeID = post.resourceType[0];
          function isResourceType(obj) { return obj.id === resourceTypeID; }
          let resourceType = wpResourceTypes.terms.find(isResourceType);
          return 'Resource <span><span class="divider"> | </span> ' + resourceType.name + '</span>'
        } 
        else { // No resource types on the post, just return the post type
          return 'Resource';
        }
        // return 'Resource';
      }
      else if (post.type === 'project') {
        return 'Project';
      }
      else if (post.type === 'staff') {
        return 'Staff';
      }
      else {
        return 'Post';
      }
    }.bind(this);

    let downloads = function() { // Return the number of downloads as a user friendly string
      if (post.type === 'resource') {
        // Count number of downloads
        if (typeof post.acf !== 'undefined' && typeof post.acf.downloads !== 'undefined') {
          if (post.acf.downloads === false) {
            return 'No downloads available';
          }
          if (post.acf.downloads.length === 0) {
            return null;
          }
          else if (post.acf.downloads.length === 1) {
            return '1 download available';
          }
          else {
            return post.acf.downloads.length + ' downloads available';
          }
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    };

    return (
      <li className={'post post--' + post.type}>
        <div className="post__meta" data-has-background="true">
          <span className="post__post-type" dangerouslySetInnerHTML={{__html: postType() }}></span>
          <h3 className="post__post-title"><a href={post.link}><span>{decodeHTML(post.title.rendered)}</span></a></h3>
          {(post.type === 'resource') && (
            <span className="post__info">{downloads()}</span>
          )}
          <TagList post={post} wpData={this.props.wpData} />
        </div>
      </li>
    );
  };
};

Post.propTypes = {
  post: PropTypes.object,
  wpData: PropTypes.object,
};

export default Post;


// WEBPACK FOOTER //
// ./src/components/Post.js